<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
body {
    background-color: #FBFDFF !important;
    font-family: 'Nunito', sans-serif;
}
.btn-labhub{
    display: flex;
    min-width: 124px;
    height: 36px;
    padding: 8px 37px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 100px;
    border: none;
    background: #3FE7DE;
    color:#ffffff;
}
h1 {
    color: #5F5F5F;
    font-family: Nunito;
    font-size: 36px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    position: relative;
    display: inline-block; /* чтобы псевдоэлемент мог быть абсолютно позиционирован относительно h1 */
    vertical-align: middle; /* для вертикального выравнивания */
    padding-left: 60px; /* чтобы создать пространство для линии */
}

h1::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%); /* для вертикального выравнивания линии */
    width: 43px;
    height: 2px;
    background: #3FE7DE;
}

h3.line{
  color: #5F5F5F;
    font-family: Nunito;
    font-size: 24px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    position: relative;
    display: inline-block; /* чтобы псевдоэлемент мог быть абсолютно позиционирован относительно h1 */
    vertical-align: middle; /* для вертикального выравнивания */
    padding-left: 40px; /* чтобы создать пространство для линии */
}
h3.line::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%); /* для вертикального выравнивания линии */
    width: 30px;
    height: 2px;
    background: #3FE7DE;
}
.mess-box{
display: flex;
width: 100%;
min-height: 100px;
padding: 20px;
align-items: center;
gap: 17px;
flex-shrink: 0;
border-radius: 5px;
background: #E3F0FF;
margin-top: 30px;
margin-bottom:40px;
color: var(--medical-dark, #193B68);
font-family: Nunito;
font-size: 16px;
font-style: normal;
font-weight: 400;
line-height: 18px; /* 128.571% */
}
</style>

<style src="@/assets/redesign.css"></style>
